"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
const DEFAULT_INVOICE = { id: "new" };
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "invoiceInput", (field, placeholder, type, ref) => {
      var _a, _b;
      return /* @__PURE__ */ jsx(
        ValueLinkTextDroppableInput,
        {
          type,
          ref,
          disabled: this.invoiceIsReadOnly(),
          value: (_b = (_a = this.fieldValue(field)) != null ? _a : this.carrierInvoice()[field]) != null ? _b : "",
          onValueChange: (value) => this.props.onFieldChange(field, value),
          placeholder,
          className: "mousetrap-allow-text"
        }
      );
    });
    __publicField(this, "fieldValue", (field) => {
      return field === "source_invoice_amount" ? this.props.sourceInvoiceAmount : this.props.sourceInvoiceNumber;
    });
    __publicField(this, "invoiceIsReadOnly", () => {
      return this.carrierInvoice() && (this.carrierInvoice().state === "approved" || this.carrierInvoice().state === "abandoned");
    });
    __publicField(this, "carrierInvoice", () => {
      return this.props.getSelectedInvoiceForGroup(DEFAULT_INVOICE);
    });
    __publicField(this, "focusNextField", () => {
      setTimeout(() => {
        const isReadOnly = this.invoiceIsReadOnly();
        const needsInvoiceAmt = !(this.props.sourceInvoiceAmount || this.carrierInvoice().source_invoice_amount) && !isReadOnly;
        const needsInvoiceNum = !(this.props.sourceInvoiceNumber || this.carrierInvoice().source_invoice_number) && !isReadOnly;
        if (needsInvoiceAmt) {
          ReactDOM.findDOMNode(this.refs.amount).focus();
        } else if (needsInvoiceNum) {
          ReactDOM.findDOMNode(this.refs.number).focus();
        } else {
          const firstRadioAssigner = document.querySelector(
            'input[name="carrier-invoice-chooser"]:checked'
          ) || document.querySelector(
            'input[name="carrier-invoice-chooser"]'
          );
          if (firstRadioAssigner) {
            firstRadioAssigner.focus();
          }
        }
      });
    });
  }
  render() {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__invoice-input-fields", children: [
      /* @__PURE__ */ jsx("h4", { children: "Verify Invoice Data" }),
      /* @__PURE__ */ jsxs("div", { className: "row load-assigner__invoice-input-fields__inputs", children: [
        /* @__PURE__ */ jsxs("div", { className: "medium-5 columns", children: [
          /* @__PURE__ */ jsx("label", { children: "Invoice Amount" }),
          /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
            /* @__PURE__ */ jsx("div", { className: "small-1 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
            /* @__PURE__ */ jsx("div", { className: "small-9 columns", children: this.invoiceInput(
              "source_invoice_amount",
              "Total Charge",
              "text",
              "amount"
            ) })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "medium-5 columns", children: [
          /* @__PURE__ */ jsx("label", { children: "Invoice Number" }),
          this.invoiceInput(
            "source_invoice_number",
            "Invoice Number",
            "text",
            "number"
          )
        ] })
      ] })
    ] });
  }
}
